import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCheckServiceModel,
  ICheckServiceRequest,
  IMappers,
  ICheckServiceResponse,
  ICheckServiceResponseError,
  TCheckServiceResponse,
} from './types';

const defaultConfig: TCheckServiceModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/check-service/',
  hostType: 'api',
} as TCheckServiceModel;

function createCheckServiceModel(parameters: ICheckServiceRequest): TCheckServiceModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckServiceOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckServiceRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckService<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICheckServiceOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCheckServiceResponse> {
  const { response, statusCode } = await httpApi.fetch(createCheckServiceModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckServiceResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckServiceResponseError);
    }
  }

  return { response, statusCode } as TCheckServiceResponse;
}

export { defaultConfig, createCheckServiceModel, fetchCheckService };
